const dataStudioEnumerators = {
  permissionRoles: [
    'executor',
    'admin',
    'planificator',
    'supervisor',
  ],
};

export default dataStudioEnumerators;
